<!-- 页面公共底部 -->
<template>
  <div class="bottom">
    <div class="bot_main">
      <div class="bot_left">
        <img src="../../assets/img/logo.png" class="bot_logo">
        <router-link tag="a" to="" target="_blank">用户协议</router-link>｜
        设计中心联系方式：0755-66826666（8793）
      </div>
      <div class="bot_right">
        友情链接：
        <a target="_blank" href="http://www.fantawild.com/">华强方特</a> 丨 
        <a target="_blank" href="http://www.fangte.com/">方特旅游</a> 丨 
        <a target="_blank" href="http://www.hqftdm.com/">方特动漫</a> 丨 
        <a target="_blank" href="http://yjy.hytch.com/">华强方特研究院</a> 丨 
        <a target="_blank" href="http://design.hytch.com/">华强方特设计院有限公司</a>
        <br/>
        <a target="_blank" href="http://project.fangte.com/">华强方特工程管理事业部 </a> 丨 
        <a target="_blank" href="http://znbt.hytch.com/">华强智能工厂 </a> 丨 
        <a target="_blank" href="http://zgb.fangte.com/">华强方特总工办</a>
        <br/>
        深圳华强方特文化科技集团内部网版权所有©2019 ALL rights reserved
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style scoped>
.bottom {
  width: 100%;
  background-color: #fff;
  height: 240px;
}
.bot_main {
  margin: 0 auto;
  color: #666;
  font-size: 15px;
  width: 1280px;
  padding: 60px 0 0 0;
  position: relative;
}
.bot_main a {
  color: #666;
}
.bot_main a:hover {
  transition: 0.5s;
  -webkit-transition: 0.5s;
  color: #6aa9ff;
}
.bot_logo {
  display: block;
  margin: 0 0 30px 0;
}
.bot_left {
  float: left;
}
.bot_right {
  float: right;
  text-align: center;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/bottom.vue